// extracted by mini-css-extract-plugin
export default {"tagsContainer":"ConversationTags_tagsContainer__9BMup","tag":"ConversationTags_tag__nkYZR"};